import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomActionButton } from 'pages/custom/shared/CustomHeader/CustomActionButton';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { ELanguageCodes } from 'static/config/language/languageConfig';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const SeafoodButtons = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const analytics = useAnalytics();

    function changeLanguage(lang: ELanguageCodes) {
        Localization.setLanguage(lang);
        setTimeout(() => {
            if (lang === ELanguageCodes.en) {
                window.location.href = '/m/seafood-en';
            } else {
                window.location.href = '/m/seafood';
            }
        }, 500);
    }

    const language = Localization.getLanguage();

    return (
        <S_SeafoodButtons className={props.className}>
            <S_Button
                iconSet="far"
                iconName="location-dot"
                text={Localization.PLACES}
                onClick={() => {
                    analytics.track('custom_button.clicked', {
                        action: 'sidebar_list.opened'
                    });
                    ctxModal.setShowListOfStories(true);
                }}
            />
            <S_Button
                iconSet="far"
                iconName="globe"
                text={language === 'en' ? 'Norsk' : 'English'}
                onClick={() => {
                    analytics.track('custom_button.clicked', {
                        action: 'change_language'
                    });
                    changeLanguage(language === 'en' ? ELanguageCodes.nb : ELanguageCodes.en);
                }}
            />
        </S_SeafoodButtons>
    );
};

const S_SeafoodButtons = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 1259px) {
        width: unset;
    }
`;

const S_Button = styled(CustomActionButton)`
    width: 100%;
    @media only screen and (min-width: 1259px) {
        min-width: 150px;
        width: unset;
    }
`;
